import { render, staticRenderFns } from "./EmailDamageRecordAssignModal.vue?vue&type=template&id=3f2fbd52"
import script from "./EmailDamageRecordAssignModal.vue?vue&type=script&lang=js"
export * from "./EmailDamageRecordAssignModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports